<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md8>
        <material-card color="green" title="Search">
          <v-form onsubmit="return false;">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    type="text"
                    name="searchText"
                    v-model="searchText"
                    id="searchText"
                    label="Email or Device Id"
                    v-on:keyup.enter="search()"
                  />
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn v-bind:disabled="searching" v-on:click="search()" color="success">Search</v-btn>
                </v-flex>
                <v-flex xs12>
                  <v-progress-circular indeterminate v-if="searching"></v-progress-circular>
                </v-flex>
                <v-flex xs12>
                  <div>{{message}}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
var restHelper = require("../restHelper").default
var middleware = require("../middleware").default

export default {
  data() {
    return {
      searchText: "",
      token: "",
      message: "",
      searching: false
    }
  },
  mounted() {
    middleware.run(this.$router)
  },
  methods: {
    async search() {
      this.searching = true

      try {
        if (this.searchText.includes("@")) {
          var result = await restHelper.findUserByEmail(this.searchText)

          if (result.data) {
            this.$router.push("user/" + result.data.userId)
          } else {
            this.message = "No matching user found"
          }
        } else {
          var result = await restHelper.getDevice(this.searchText)

          if (result.data) {
            this.$router.push("device/" + result.data.deviceId)
          } else {
            this.message = "No matching device found"
          }
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.message = error.response.data.message
        } else {
          this.message = error.message
        }
      }

      this.searching = false
    }
  }
}
</script>